module.exports = __webpack_public_path__ + "img/smoke-detector-md.905b0c89.svg";